// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
/** Lazy loader for the disconnect-plan modal container. */ export const DisconnectPlanModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-disconnect-plan-dialog" */ "./DisconnectPlanModalContainer")).then((module)=>({
            default: module.DisconnectPlanModalContainer
        }));
/** Lazy loading wrapper for the disconnect-plan modal container. */ export const LazyDisconnectPlanModalContainer = /*#__PURE__*/ lazy(DisconnectPlanModalContainerLazyLoader);
